<div *ngIf="showButton" class="nav-container">
    <div fxLayout="row" fxLayoutAlign="end center">
        <mat-icon class="customiseCloseIcon" (click)="toggleNav()">{{ closeIconLabel }}</mat-icon>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" [tourAnchor]="DesignerTourSteps.flips.anchorId!">
        <div
            *ngFor="let actionBtn of actionsBtns; let i = index"
            [@slideInOut]
            class="customiseActionIcon"
            [ngClass]="{ disabled: !meshes.length }"
        >
            <mat-icon (click)="!isStepTourActive && actions(i, actionBtn)">{{ actionBtn.label }}</mat-icon
            ><br />
            <mat-hint>{{ actionBtn.action }}</mat-hint>
        </div>
    </div>
    <hr />
    <div fxLayout="row" fxLayoutAlign="center center" [tourAnchor]="DesignerTourSteps.colourPicker.anchorId!">
        <colour-picker></colour-picker>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" [tourAnchor]="DesignerTourSteps.getCount.anchorId!">
        <button class="customiseCountBox" mat-button (click)="!isStepTourActive && openDialogBox()">
            {{ "designer.actionBtnCont.details.getCount" | translate }}
        </button>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" [tourAnchor]="DesignerTourSteps.totalBlocks.anchorId!">
        <a class="customiseCountBox"
            >{{ "designer.actionBtnCont.details.totalBlock" | translate }} = {{ meshes.length }}</a
        >
    </div>
    <hr />
    <div class="save-buttons">
        <div
            *ngFor="let saveBtn of filteredSaveBtns; let i = index"
            [@slideInOut]
            class="customiseSaveActionIcon"
            [ngClass]="{ disabled: isDisabled(saveBtn), 'active-tour': isStepTourActive }"
            (click)="!isStepTourActive && saveActions(saveBtn.iconlabel)"
            [tourAnchor]="saveBtn.iconlabel"
        >
            <mat-icon>{{ saveBtn.iconlabel }}</mat-icon>
            <mat-hint>{{ saveBtn.iconHint1 }}</mat-hint>
        </div>
    </div>
</div>
<div class="guide-actions-btn-container">
    <button
        mat-button
        *ngIf="!showButton"
        [tourAnchor]="DesignerTourSteps.guide.anchorId!"
        (click)="!isStepTourActive && triggerOnBoardingDialog()"
        [class.customiseBtn]="isStepTourActive"
    >
        {{ "designer.actionBtnCont.button.guidebtn" | translate }}
    </button>
    <button
        mat-button
        *ngIf="!showButton"
        [tourAnchor]="DesignerTourSteps.actions.anchorId!"
        (click)="!isStepTourActive && toggleNav()"
        [class.customiseBtn]="isStepTourActive"
    >
        {{ "designer.actionBtnCont.button.actionBtn" | translate }}
    </button>
</div>
